export default "<p>\n  img-preview works!\n</p>\n"